var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v("Te verwijderen databases")]),
      _c(
        "w-list",
        _vm._l(_vm.availableDbs, function (db) {
          return _c(
            "w-list-item",
            { key: db.id, attrs: { to: `/dangling-dbs/${db.id}` } },
            [_c("w-list-item-text", [_vm._v(_vm._s(db.toString()))])],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }